import React from "react";
import Grid from "@mui/material/Grid";
import { makeStyles } from "@mui/styles";
import Typography from "@mui/material/Typography";
import logoWird107x39 from "../assets/logoWird107x39.svg";

const StylesHeader = makeStyles({
  root: {
    backgroundColor: "#181533",
    padding: "16px 24px",
    zIndex: "1",
    width: "100%",
    height: "54px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    alignContent: "center",
  },
});

const headerTitle = {
  fontSize: "16px",
  fontWeight: "500",
  fontFamily: "Asap",
  color: "#22EDA3",
  lineHeight: "20px",
};

/**
 * Componente header de toda la app
 */
const Header = () => {
  const classes = StylesHeader();

  return (
    <>
      <Grid container className={classes.root}>
        <Typography sx={headerTitle}>Automatizaciones</Typography>
        <img
          src={logoWird107x39}
          alt='logo wird white'
          width={107}
          height={39}
        />
      </Grid>
    </>
  );
};

export default Header;
